import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { circularProgressIndicatorTheme } from '../CircularProgressIndicator/CircularProgressIndicator.stylex';
import { circularProgressIndicatorStyles, } from '../CircularProgressIndicator';
import { indeterminateCircularProgressIndicatorStyles, } from './IndeterminateCircularProgressIndicator.styles';
import { Base } from '../Base';
// https://github.com/material-components/material-web/blob/main/progress/internal/progress.ts
// https://github.com/material-components/material-web/blob/main/progress/internal/circular-progress.ts
export const IndeterminateCircularProgressIndicator = forwardRef(function IndeterminateCircularProgressIndicator(props, forwardedRef) {
    const { styles, sx, disabled, children, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'CircularProgressIndicator',
        styles: [
            circularProgressIndicatorStyles,
            indeterminateCircularProgressIndicatorStyles,
            styles,
        ],
    });
    return (_jsxs(Base, { ...other, sx: [
            circularProgressIndicatorTheme,
            globalStyles,
            combineStyles('host'),
            sx,
        ], ref: forwardedRef, children: [_jsx("div", { ...getStyles('layer', 'progress'), role: 'progressbar', "aria-label": props['aria-label'] ?? undefined, children: _jsxs("div", { ...getStyles('layer', 'spinner'), children: [_jsx("div", { ...getStyles('layer', 'left'), children: _jsx("div", { ...getStyles('layer', 'circle', 'leftCircle', disabled && 'circle$disabled') }) }), _jsx("div", { ...getStyles('layer', 'right'), children: _jsx("div", { ...getStyles('layer', 'circle', 'rightCircle', disabled && 'circle$disabled') }) })] }) }), children ? _jsx("div", { ...getStyles('layer'), children: children }) : null] }));
});
